import React from "react";
import { useTranslation } from "react-i18next";
import Button from "components/Button";
import Modal from "components/Modal";
import { features } from "pages/Layout/Header/components/WhatsNew";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "store";
import { hideFeatureAnnouncementPopup } from "store/commonSlice";
import { AnalyticsEvent } from "utils";
import { useSiteImage } from "hooks/useSiteImage";

const FeatureAnnouncementPopup = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { showFeatureAnnouncementPopup } = useAppSelector((state) => state.common);
  const latestFeature = features[1];
  const latestFeatureImage = useSiteImage(latestFeature.imageSlot, latestFeature.image);

  function onClose() {
    dispatch(hideFeatureAnnouncementPopup());
  }

  React.useEffect(() => {
    if (showFeatureAnnouncementPopup) {
      AnalyticsEvent("New_Feature_Pop_up_Shown", "", "click");
    }
  }, [showFeatureAnnouncementPopup]);

  return (
    <Modal onClose={onClose} show={showFeatureAnnouncementPopup} bodyClassName="!overflow-hidden !max-w-[480px]  !border-grey-light dark:!border-black-300" className="!z-[9990]">
      <div className="flex flex-col gap-5 p-6 bg-black-100 text-white">
        <h2 className="text-h2">{t("common:modals.feature_announcement.title")}</h2>

        <img src={latestFeatureImage} />

        <h4 className="text-h4">{t(latestFeature.titleKey)}</h4>

        {latestFeature.description && latestFeature.description()}

        <div className="flex flex-col gap-2">
          {latestFeature.button && latestFeature.button({ navigateFunc: navigate, callback: onClose, fromBanner: true })}
          <Button className="btn-secondary" onClick={onClose}>
            {t("common:modals.feature_announcement.close")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default FeatureAnnouncementPopup;
